module.exports = __webpack_public_path__ + "static/media/montagem_ornamentos_es.76914e84.png";